import { render, staticRenderFns } from "./health-record-list.vue?vue&type=template&id=3ba29b3e&scoped=true"
import script from "./health-record-list.vue?vue&type=script&lang=js"
export * from "./health-record-list.vue?vue&type=script&lang=js"
import style0 from "./health-record-list.vue?vue&type=style&index=0&id=3ba29b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba29b3e",
  null
  
)

export default component.exports